import type { AssetTypeSeverityGridTabProps } from "./asset-type-severity-grid-tab.type";

import SeverityGridEditor from "@/components/AssetType/SeverityGridEditor";

import { useAssetTypeSeverityGrid } from "./asset-type-severity-grid-tab.hook";

export const AssetTypeSeverityGridTab = ({
  assetType,
  loading,
}: AssetTypeSeverityGridTabProps) => {
  const {
    defectTree,
    onUpdateDefectTree,
    translation,
    onUpdateTranslation,
    resetKey,
  } = useAssetTypeSeverityGrid(assetType);

  return (
    <SeverityGridEditor
      assetTypeId={assetType?.id}
      loading={loading}
      defectTree={defectTree ?? {}}
      translation={translation}
      resetKey={resetKey}
      onUpdateDefectTree={onUpdateDefectTree}
      onUpdateTranslation={onUpdateTranslation}
    />
  );
};
